import { groupBy } from "lodash";
import { writable } from "svelte/store";

import { HttpPromise } from "@shared/svelte/Modules/ApiService";

export interface SfPrice {
  id: number;
  bottles: number;
  sku: string;
  distributor_id: number;
  inventory_id: number;
  price_per_unit: number;
  price_per_case: number;
  list_price_per_unit: number | null;
  list_price_per_case: number | null;
  price_assortment_id: number | null;
  price_group_id: number | null;
  assortment_type: "case" | "unit" | null;
  price_group: {
    price_group_id: number;
    name: string;
    description: string;
  } | null;
}

export interface SfPriceStore {
  sfPrices: SfPrice[];
  getPricesForInventory(inventoryId: number): SfPrice[];
  getListPricesForInventory(inventoryId: number): SfPrice[];
}

const store = writable<SfPriceStore>({
  sfPrices: [],
  getPricesForInventory: _ => [],
  getListPricesForInventory: _ => [],
});

const { set, subscribe } = store;

const setFromPrices = (sfPrices: SfPrice[]): void => {
  const pricesByInventory = groupBy(sfPrices, "inventory_id");

  const getPricesForInventory = (inventoryId: number): SfPrice[] =>
    pricesByInventory[inventoryId] || [];

  const getListPricesForInventory = (inventoryId: number): SfPrice[] =>
    getPricesForInventory(inventoryId).filter(price => price.list_price_per_unit);

  set({
    sfPrices,
    getListPricesForInventory,
    getPricesForInventory,
  });
};

export default { subscribe, setFromPrices };
